<template>
  <div class="mock-interview-container">
    <div class="mock-interview-container-header">
      <!-- tab -->
      <div class="mock-interview-container-header-tab">
        <span :class="{'active': tabIndex === 0}" @click="tabIndex = 0">AI 模拟面试</span>
        <span :class="{'active': tabIndex === 1}" @click="tabIndex = 1">我要自己问</span>
        <i :class="['mock-interview-container-header-tab-sign', `position-${tabIndex}`]"></i>
      </div>

      <!-- close -->
      <div class="mock-interview-container-header-close" @click="$emit('close')">
        <i class="iconfont iconx"></i>
      </div>

    </div>
    <div v-if="tabIndex === 0" class="mock-interview-content">
      <template v-if="isMemberAccount" >
        <div class="mock-interview">
          <div v-if="isLoading1" class="loading-content">
            <img src="https://logo.wondercv.com/banners/FwZXxCDEJSmIZWQ.gif" class="loading-icon" alt="">
          </div>
          <div v-else-if="noResult" class="no-result">AI开小差了，请重新生成试试～</div>
          <template v-else>
            <div
              v-for="(item, index) in interviewResult"
              :key="index"
              class="interview-result-item"
            >
              <div class="message other">
                <div class="avatar-wrapper">
                  <img src="https://logo.wondercv.com/banners/OSklM7tbYeEKNLH.png" alt="">
                </div>
                <div class="message-text-content">
                  <div class="message-text">{{ item.question }}</div>
                </div>
              </div>
              <div class="message me">
                <div class="avatar-wrapper">
                  <img :src="userAvatar" alt="">
                </div>
                <div class="message-text-content">
                  <div class="message-text">面试思路：{{ item.logic }}</div>
                  <br />
                  <div class="message-text">面试话术：{{ item.answer }}</div>
                </div>
              </div>
            </div>
            <!-- <div
              class="common-btn more-btn"
              @click="fetchMockInterviewData({
                ask_type: 'answer',
                is_continue: true,
                change: false
              })"
            >获取新的3个问题和答案，消耗次数1次</div> -->
          </template>
        </div>
        <div class="mock-interview-footer">
          <div class="source">Powered By ChatGPT</div>
          <div class="btn-content">
            <div
              class="btn-item"
              @click="fetchMockInterviewData({
                ask_type: 'answer',
                is_continue: false,
                change: !noResult
              })"
            >
              {{ noResult ? '重新生成' : '换一批'}}
            </div>
            <div class="btn-item" @click="handleCopyAllContent">复制所有内容</div>
          </div>
        </div>
      </template>
      
      <div v-else class="empty-image-wrapper">
        <img class="empty-image" src="https://logo.wondercv.com/banners/g5XICasbmpyDvNC.png" />
        <div class="empty-btn" @click="handleClickUpVip">开通会员查看所有答案</div>
      </div>
    </div>
    <div v-if="tabIndex === 1" class="mock-interview-content">
      <div class="input-box">
        <input v-model="inputValue" type="text" placeholder="请输入面试问题">
        <button class="button fill" @click="fetchInterviewAnswer">GO</button>
      </div>
      <div class="question-box">
        <div
          class="question-item"
          v-for="(item, index) in QUESTIONS"
          :key="index"
          @click="handleClickQuestion(item)"
        >
          {{ item }}
        </div>
      </div>
      <div class="answer-content">
        <div class="result-header">
          生成结果
        </div>
        <div class="answer">
          <div v-if="isMemberAccount" class="answer-text">
            <div v-if="isLoading2" class="loading-content">
              <img src="https://logo.wondercv.com/banners/FwZXxCDEJSmIZWQ.gif" class="loading-icon" alt="">
            </div>
            <div v-else-if="noResultBySelf" class="no-result">AI开小差了，请重新生成试试～</div>
            <div v-else-if="answer" class="answer-text-content">
              <div class="message-text">面试思路：{{ answer.logic }}</div>
              <br />
              <div class="message-text">面试话术：{{ answer.answer }}</div>
            </div>
          </div>
          <div v-else class="empty-image-wrapper">
            <img class="empty-image" style="height: 195px;" src="https://logo.wondercv.com/banners/6SjFuXfZThVLtZV.png" />
            <div class="empty-btn" @click="handleClickUpVip">开通会员查看所有答案</div>
          </div>
        </div>
      </div>
      <div v-if="isMemberAccount" class="mock-interview-footer">
        <div class="source">Powered By ChatGPT</div>
        <div class="btn-content">
          <div class="btn-item" @click="fetchInterviewAnswer">
            <i class="iconfont iconhuanyihuan"></i>
            重试
          </div>
          <div class="btn-item" @click="handleCopyAnswerContent">复制</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { copyToClipboard } from '../../assets/js/util'
import api from '../../api/index'

const QUESTIONS = [
  '你认为在工作中你的优点和缺点有哪些？',
  '上一份工作为什么离职？',
  '你的个人核心竞争力是什么？',
  '在5年内，你的职业规划是什么？',
  '为什么选择我们公司？',
  '你怎样看待自己的失败或成功？',
]
export default {
  data() {
    return {
      isLoading1: false,
      isLoading2: false,
      noResult: false,
      noResultBySelf: false,
      tabIndex: 0,
      inputValue: '',
      QUESTIONS,
      interviewResult: [],
      answer: null,
      payAlertState: false,
    }
  },
  computed: {
    ...mapState('me', [ 'personInfo' ]),
    ...mapState('app', ['alertData']),
    isMemberAccount() {
      return this.personInfo.is_membership
    },
    userAvatar() {
      return this.personInfo.avatar_url
    }
  },
  methods: {
    handleClickQuestion(text) {
      this.inputValue = text;
    },
    async fetchInterviewAnswer() {
      try {
        if (!this.inputValue) return this.$message.error('请先输入面试问题');
        this.fetchMockInterviewData({
          ask_type: 'answer',
          is_continue: false,
          question: this.inputValue,
          change: false
        })
      } catch (error) {
        console.log(error)
      }
    },
    handleClickUpVip() {
      this.$store.dispatch('app/setAlertData', {
        show: true,
        type: 'upVip',
        browseType: 'aiMockInterview'
      })
    },
    async handleCopyAllContent() {
      let content = '';
      this.interviewResult.forEach((item, index) => {
        content += `问题${index + 1}：${item.question}\n面试思路：${item.logic}\n面试话术：${item.answer}\n\n`
      });
      await copyToClipboard(content);
      this.$message.success('已复制内容')
    },
    async handleCopyAnswerContent() {
      if (!this.answer) return this.$message.error('请先输入面试问题')
      const content = `问题：${this.inputValue}\n面试思路：${this.answer.logic}\n面试话术：${this.answer.answer}\n\n`
      await copyToClipboard(content);
      this.$message.success('已复制内容')
    },
    async fetchMockInterviewData(query = {}) {
      if (!this.isMemberAccount) return;
      const { question, is_continue } = query
      try {
        const { token } = this.$route.params
        if (!token) return console.log('没有简历token')
        !!question ? (this.isLoading2 = true) : (this.isLoading1 = true)

        const { code, data } = await api.cvsV3.sendMockInterview(token, query);

        !!question ? (this.isLoading2 = false) : (this.isLoading1 = false)

        !!question ? (this.noResultBySelf = false) : (this.noResult = false);

        if (code === 2030) {
          return this.$message.error('AI模拟面试次数不足')
        }

        if ((Array.isArray(data?.result) && !data?.result?.length) || !data?.result || code !== 1000) {
          !!question ? (this.noResultBySelf = true) : (this.noResult = true)
          return 
        }

        if (!!question) {
          this.answer = data?.result || null
        } else if (is_continue) {
          this.interviewResult = [...this.interviewResult, ...(data.result || [])]
        } else {
          this.interviewResult = data.result || []
        }
      } catch (error) {
        !!question ? (this.isLoading2 = false) : (this.isLoading1 = false)
        !!question ? (this.noResultBySelf = true) : (this.noResult = true)
        console.log(error)
      }
    }
  },
  watch: {
    'alertData.show': {
      handler(state) {
        if (state && this.alertData.type === 'mock-interview' && !this.interviewResult.length && this.isMemberAccount) {
          this.fetchMockInterviewData({
            ask_type: 'answer',
            is_continue: false,
            change: false
          })
        } 
      },
      deep: true
    }
  }
}
</script>
<style lang="scss" scoped>
.mock-interview-container {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 800px;
  border-radius: 8px;
  overflow: hidden;
  &-header {
    height: 68px;
    padding: 0 32px;
    background: #F8FAFF;
    border-radius: 8px 8px 0 0;
    display: flex;
    align-items: center;
    justify-content: space-between;

    &-tab {
      position: relative;
      display: flex;
      gap: 30px;
      font-size: 18px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #9C9C9C;
      line-height: 1;

      >span {
        display: inline-block;
        padding: 10px 0;
        cursor: pointer;
        &.active {
          color: #404040;
          font-weight: bold;
        }
      }

      &-sign {
        position: absolute;
        bottom: 0;
        width: 16px;
        height: 2px;
        background: #FF6644;
        border-radius: 1px;
        transition: left 0.4s ease;

        &.position-0 {
          left: 40px;
        }

        &.position-1 {
          left: 161px;
        }

      }

    }

    &-close {
      cursor: pointer;
      padding: 6px;
      margin-right: -6px;
      .iconx {
        font-size: 24px;
        font-weight: bold;
      }
    }

  }
  .common-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 46px;
    background-color: #FF5733;
    color: #fff;
    border-radius: 22px;
    box-sizing: border-box;
    cursor: pointer;
    padding: 0 24px;
    width: max-content;
  }
  .more-btn {
    margin: 0 auto;
    border: 1px solid #FF5733;
    color: #FF5733;
    background-color: #fff;
  }
  .mock-interview-content {
    background-color: #fff;
    padding: 24px 32px;
    box-sizing: border-box;
    .mock-interview {
      padding: 24px 12px 12px;
      border: 1px solid #DEDFE1;
      border-radius: 4px;
      height: 380px;
      overflow-y: scroll;
      
      .interview-result-item {
        .message {
          display: flex;
          align-items: flex-start;
          margin-bottom: 12px;
          &.me {
            flex-direction: row-reverse;
            .avatar-wrapper {
              margin-left: 12px;
              margin-right: 0;
            }
            .message-text-content {
              background-color: #FF5733;
              border-radius: 6px 0 6px 6px;
              color: #fff;
            }
          }
          .avatar-wrapper {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 32px;
            height: 32px;
            border-radius: 50%;
            overflow: hidden;
            margin-right: 12px;
            flex-shrink: 0;
            img {
              width: 32px;
              height: 32px;
              object-fit: cover;
            }
          }
          .message-text-content {
            padding: 12px 16px;
            border-radius: 0 6px 6px 6px;
            background-color: #F5F6FA;
            font-size: 14px;
            line-height: 16px;
            color: #404040;
            max-width: 432px;
          }
        }
      }
    }
    .mock-interview-footer {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-top: 18px;
      .source {
        font-size: 14px;
        line-height: 16px;
        color: #BABABA;
      }
      .btn-content {
        display: flex;
        align-items: center;
        .btn-item {
          display: flex;
          align-items: center;
          padding: 0 18px;
          height: 32px;
          border: 1px solid #FF5733;
          color: #FF5733;
          font-size: 14px;
          border-radius: 4px;
          cursor: pointer;
          .iconfont {
            font-size: 12px;
            margin-right: 4px;
          }
          &:nth-child(2) {
            margin-left: 16px;
            background-color: #FF5733;
            color: #fff;
          }
        }
      }
    }
    .input-box {
      display: flex;
      gap: 24px;
      align-items: center;
      height: 44px;
      border-radius: 4px;
      border: 1px solid #ECECEC;
      padding: 0 6px 0 12px;
      margin-bottom: 16px;

      >input {
        height: 100%;
        flex: 1;
        border: none;
        background: transparent;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        color: #404040;
        line-height: 1;
      }
      .button {
        padding: 8px 16px;
        border-radius: 4px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        line-height: 1;
        border-width: 1px;
        border-style: solid;
        display: flex;
        align-items: center;
        gap: 2px;
        background: transparent;

        &:hover {
          opacity: 0.8;
        }

        &.transparent {
          border-color: #FF6644;
          color: #FF6644;
        }

        &.fill {
          border-color: #FF6644;
          background: #FF6644;
          color: #FFF;
        }

        &.disabled {
          // cursor: not-allowed;
          opacity: 0.8;
        }

        i {
          font-size: 14px;
        }
      }
    }
    .question-box {
      display: flex;
      flex-wrap: wrap;
      margin-bottom: 16px;
      .question-item {
        display: flex;
        align-items: center;
        padding: 0 24px;
        border-radius: 20px;
        border: 1px solid #ECECEC;
        font-size: 12px;
        color: #404040;
        height: 30px;
        margin-right: 8px;
        margin-bottom: 8px;
        cursor: pointer;
        &:hover {
          border-color: #FF5733;
          color: #FF5733;
        }
      }

    }
    .answer-content {
      width: 100%;
      border-radius: 4px;
      border: 1px solid #DEDFE1;
      overflow: hidden;
      .result-header {
        display: flex;
        align-items: center;
        height: 38px;
        padding: 0 16px;
        font-size: 14px;
        color: #404040;
        background-color: #F9F9F9;
        font-weight: 500;
      }
    }
    .answer-text {
      height: 198px;
      overflow-y: scroll;
      padding: 16px;
      box-sizing: border-box;
      font-size: 14px;
      line-height: 16px;
      color: #404040;
    }
    .empty-image-wrapper {
      position: relative;
      .empty-image {
        width: 100%;
        height: 378px;
        object-fit: cover;
      }
      .empty-btn {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        &:hover {
          background-color: #FF8569;
        }
        @extend .common-btn;
      }
    }
    .loading-content {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
      .loading-icon {
        width: 30px;
        height: 30px;
      }
    }
    .no-result {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
      font-size: 14px;
      color: #9C9C9C;
    }
  }
  ::-webkit-scrollbar {
    display: none;
  }
}
</style>